import { message } from "antd";
import { TOKEN_KEY, USER_DATA_KEY } from "../../constants/AppConstants";
import httpAuth from "../httpAuth";
import http from "../http";
import { getDefaultBlog } from "./blogAction";
import { modalState } from "./modalAction";

const showLogin = () => {
  return (dispatch) => dispatch({ type: "SHOW_LOGIN_MODAL" });
};

const hideLogin = () => {
  return (dispatch) => dispatch({ type: "HIDE_LOGIN_MODAL" });
};

const getUser = (key, _history) => {
  return (dispatch) => {
    http
      .post("/auth/login/", key)
      .then((res) => {
        const rs = res.data?.data;

        localStorage.setItem(TOKEN_KEY, rs.token);
        localStorage.setItem(USER_DATA_KEY, JSON.stringify(rs));
        dispatch({ type: "SET_LOGIN", payload: rs });
        dispatch(getDefaultBlog());
        dispatch(modalState(false));
        window.location.reload();
        message.success("Login Successful");
      })
      .catch((err) => {
        localStorage.setItem(TOKEN_KEY, "");
        dispatch(modalState(false));
        message.error(`Login Failed, ${err.response?.data?.message[0]}`);
        console.error("Login Err", err.response?.data?.message[0]);
      });
  };
};

const login = (body, history) => {
  return (dispatch) => {
    httpAuth
      .post("/rest-auth/login/", body)
      .then((res) => {
        const rs = res.data;
        dispatch(getUser(rs, history));
      })
      .catch((err) => {
        localStorage.setItem(TOKEN_KEY, "");
        dispatch(modalState(false));
        message.error(err.response?.data?.non_field_errors[0]);
      });
  };
};

const logout = () => {
  return (dispatch) => {
    httpAuth
      .get("/rest-auth/logout/")
      .then((res) => {})
      .catch((err) => {
        localStorage.setItem(TOKEN_KEY, "");
        // if (body!==null)
        // message.error(err.response?.data.message[0])
        console.error(err);
      });
  };
};

const signup = (body, history) => {
  return (dispatch) => {
    httpAuth
      .post("/rest-auth/registration/", body)
      .then((rs) => {
        dispatch(modalState(false));
        window.location.reload();
        message.success("Registered Successfully");
      })
      .catch((err) => {
        console.error(err);
        dispatch(modalState(false));
        message.success("Registeration Failed. Please try again");
      });
  };
};

export { showLogin, hideLogin, login, signup, logout };
